const ID_REGEX = /^[a-z]{2}$/;
const VALUE_REGEX = /^[a-zA-Z0-9._-]{1,10}$/;
const COHORT_REGEX = /^([a-z]{2}:[a-zA-Z0-9._-]{1,10}\|){0,}$/;
export const COHORTS_COOKIE_NAME = 'rcgCohorts';
export const COHORTS_COOKIE_PATH = '/';
export const COHORTS_COOKIE_SAMESITE = 'lax';
/**
 * Inserts or updates a cohort in the cookie value.
 * If the cohort already exists, it will be replaced with the new value, otherwise it will be appended.
 * If the cookie value is invalid, it will be reset to an empty string.
 * @param cookieValue current cookie value
 * @param id cohort id (app id). Must be 2 lowercase letters.
 * @param value cohort value. Must be 1-10 alphanumeric characters, dots, underscores, or hyphens.
 * @returns updated cookie value
 */
export function updateCohort(cookieValue, id, value) {
    if (!ID_REGEX.test(id)) {
        throw new Error(`Invalid cohort id: ${id}. It should be 2 lowercase letters.`);
    }
    if (!VALUE_REGEX.test(value)) {
        throw new Error(`Invalid cohort value: ${value}. It should be 1-10 alphanumeric characters, dots, underscores, or hyphens.`);
    }
    cookieValue = cookieValue || '';
    if (cookieValue && !COHORT_REGEX.test(cookieValue)) {
        // clean up the cookie value if it doesn't match the expected format
        cookieValue = '';
    }
    const appValue = `${id}:${value}|`;
    if (cookieValue.includes(id)) {
        // cookie already contains this app, let's replace it:
        const regex = new RegExp(`${id}:.*?\\|`);
        return cookieValue.replace(regex, appValue); // "${id}:{anything}|"
    }
    return cookieValue + appValue;
}
/**
 * Parses the cohort cookie value and returns an object with cohort ids as keys and their values.
 * If the cookie value is invalid, an empty object is returned.
 * @param cookieValue current cookie value
 * @returns an object with cohort ids as keys and their values
 */
export function parseCohorts(cookieValue) {
    if (!cookieValue || !COHORT_REGEX.test(cookieValue)) {
        return {};
    }
    const cohorts = {};
    const pairs = cookieValue.split('|');
    for (const pair of pairs) {
        const [id, value] = pair.split(':');
        if (id && value) {
            cohorts[id] = value;
        }
    }
    return cohorts;
}
//# sourceMappingURL=cohorts-cookie.js.map